import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=1bf8b510&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8b510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf8b510')) {
      api.createRecord('1bf8b510', component.options)
    } else {
      api.reload('1bf8b510', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=1bf8b510&scoped=true&", function () {
      api.rerender('1bf8b510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Navigation.vue"
export default component.exports